export default __webpack_public_path__ + "static/media/logo.69bc931b.png";